/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Search from "../../../Common/Search";
import Sorting from "../../../Common/Sorting";
import {
  sortingReferCodeList,
  verifyValuesAffiliate,
  withdrawffiliate,
} from "../../../../utilities/enums/index";
import { connect } from "react-redux";
import { BiLoaderAlt } from "react-icons/bi";
import MetaHead from "../../../Common/Metahead";
import { useTranslation } from "react-i18next";
import Paginations from "../../../Common/Pagination";
import {
  affiliateList,
  affiliateWithdraw,
} from "../../../../stores/actions/affiliate.actions.types";
import AffiliateWithdrawalsTable from "../../../Tables/AffiliateWithdrawalsTable";
import { useParams } from "react-router-dom";

const AffiliateWithdrawals = ({ affiliateWithdraw, loading, page, id }) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [reload, setReload] = useState(false);
  const [affilates, setAffilates] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, total: 0 });
  const [sorting, setSorting] = useState([
    {
      whom: "updatedAt",
      order: "desc",
    },
  ]);

  useEffect(() => {
    getAffilateList(search, pagination.page, sorting, status);
  }, [search, sorting, pagination.page, status, reload]);

  const getAffilateList = (q = search, page, sort, status) => {
    const callback = (data) => {
      if (data.success) {
        const { total, pages, withdraws } = data?.data;
        setPagination((prev) => ({
          ...prev,
          total: total || 0,
          pages: pages || 1,
        }));
        setAffilates(withdraws);
      }
    };

    let request = {
      id,
      callback,
      data: { q, page, sort, status },
    };
    affiliateWithdraw(request);
  };

  const handleChangeSorting = (value) => {
    const sort = JSON.parse(value);
    setSorting([sort]);
  };

  const handleChangeStatus = (value) => {
    setStatus(value);
  };

  return (
    <div>
      <MetaHead title={t("withdraw-list")} />
      <div className='flex flex-col sm:flex-row justify-end mb-3 gap-2'>
        <Search
          search={search}
          placeholder='Search by user email or name'
          setSearch={setSearch}
        />
        <Sorting
          name={"Status"}
          values={withdrawffiliate}
          onChange={handleChangeStatus}
        />
        <Sorting
          name={"Sort"}
          values={sortingReferCodeList}
          onChange={handleChangeSorting}
        />
      </div>
      {loading ? (
        <div className='flex dark:bg-boxdark bg-white items-center justify-center min-h-96'>
          <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
        </div>
      ) : (
        <div>
          <AffiliateWithdrawalsTable
            affilates={affilates}
            setAffilates={setAffilates}
            setReload={setReload}
            reload={reload}
            page={page}
          />
          <Paginations pagination={pagination} setPagination={setPagination} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});
export default connect(mapStateToProps, {
  affiliateWithdraw,
})(AffiliateWithdrawals);
